/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainPaymentMethodEnum {
  'PaymentMethodCash' = 'cash',
  'PaymentMethodCard' = 'card',
}

export type DomainPaymentMethod = DomainPaymentMethodEnum